import PropTypes from 'prop-types';

import { PRODUCTS_PREDICTIONS_LIMIT } from '@/common/constants';
import {
  BaseDefaultProps,
  BasePropTypes,
} from '@/common/proptypes/Base/Base.proptypes';
import {
  PUSH_PRODUCTS_FORM_ADD_TO_CART,
  PUSH_PRODUCTS_FORM_CART,
  PUSH_PRODUCTS_FROM_DETAIL,
} from '@/ebat/constants';

export const PushPredictionsDefaultProps = {
  ...BaseDefaultProps,
  addToCartOptions: null,
  handleDisableIA: null,
  context: null,
  limit: PRODUCTS_PREDICTIONS_LIMIT,
  onProductsNotEmpty: () => {},
  products: [],
  refetchCart: () => null,
  slidesToShow: 4,
  source: null,
};

export const PushPredictionsPropTypes = {
  ...BasePropTypes,
  addToCartOptions: PropTypes.shape({}), // Defined in /blocks/Products/Product/Product
  handleDisableIA: PropTypes.func,
  context: PropTypes.string,
  limit: PropTypes.number,
  onProductsNotEmpty: PropTypes.func,
  products: PropTypes.arrayOf(
    PropTypes.PropTypes.shape({
      product: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      }),
      quantity: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    }),
  ),
  refetchCart: PropTypes.func,
  slidesToShow: PropTypes.number,
  source: PropTypes.oneOf([
    PUSH_PRODUCTS_FORM_ADD_TO_CART,
    PUSH_PRODUCTS_FORM_CART,
    PUSH_PRODUCTS_FROM_DETAIL,
  ]),
};
